/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { AccountInfoStatus, UserComplianceDocumentsStatus } from "~/constants";

const complianceConfig: {
  check: (complianceStatus: number | null) => boolean;
  status: AccountInfoStatus;
}[] = [
  {
    check: (complianceStatus) => complianceStatus === UserComplianceDocumentsStatus.NOT_FOUND,
    status: AccountInfoStatus.MISSING,
  },
  {
    check: (complianceStatus) => complianceStatus === UserComplianceDocumentsStatus.PENDING,
    status: AccountInfoStatus.PENDING,
  },
  {
    check: (complianceStatus) => complianceStatus === UserComplianceDocumentsStatus.REJECTED,
    status: AccountInfoStatus.REJECTED,
  },
  {
    check: (complianceStatus) => complianceStatus === UserComplianceDocumentsStatus.APPROVED,
    status: AccountInfoStatus.APPROVED,
  },
  {
    check: (complianceStatus) => complianceStatus === UserComplianceDocumentsStatus.DRAFT,
    status: AccountInfoStatus.DRAFT,
  },
];

const getComplianceStatus: (complianceStatus: number | null) => AccountInfoStatus = (complianceStatus) => {
  return complianceConfig.find((row) => row.check(complianceStatus))?.status ?? AccountInfoStatus.MISSING;
};

export default getComplianceStatus;
